import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../../../components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import { Button } from "../../../components/ui/button";
import { Link } from "react-router-dom";
import Donate from "./Donate";

interface HeroCarouselProps {
  images: string[];
  title: string;
  description: string;
  position: "items-start" | "items-end" | "items-center";
  link?: string;
}

export default function HeroCarousel({
  images,
  title,
  description,
  position,
  link,
}: HeroCarouselProps) {
  return (
    <section className="w-full bg-white">
      <div className="relative w-full overflow-hidden">
        <Carousel
          opts={{
            loop: true,
            align: "start",
          }}
          plugins={[
            Autoplay({
              delay: 7000,
            }),
          ]}
        >
          <CarouselContent>
            {images.map((image, index) => (
              <CarouselItem key={index} className="w-full flex-shrink-0">
                <div className="relative w-full h-[calc(100vh-220px)]">
                  <img
                    src={image}
                    alt={`Slide ${index + 1}`}
                    className="object-cover w-full h-[calc(100vh-220px)] absolute inset-0"
                  />
                  <div className="absolute inset-0 bg-black/60" />
                  <div
                    className={`absolute inset-0 flex px-4 lg:px-24 flex-col ${position} justify-center text-white`}
                  >
                    <h1 className="text-4xl lg:text-6xl pb-4 font-light text-white">
                      {title}
                    </h1>
                    <div className="w-full md:w-1/2">
                      <p className="mt-4 text-base lg:text-xl font-light text-white">
                        {description}
                      </p>
                    </div>

                    <Donate />
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="absolute left-4 top-1/2 -translate-y-1/2 bg-white text-gray-950 z-10" />
          <CarouselNext className="absolute right-4 top-1/2 -translate-y-1/2 bg-white text-gray-950 z-10" />
        </Carousel>
      </div>
    </section>
  );
}
